import axios from 'axios';

function getRuntimeApiBase() {
  if (typeof window !== 'undefined' && window.__API_URL) return window.__API_URL;
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  try { if (typeof window !== 'undefined' && window.location) return window.location.origin + '/api'; } catch(e){}
  return '/api';
}

const instance = axios.create({ baseURL: getRuntimeApiBase(), headers: { 'Content-Type': 'application/json' } });

// Response interceptor: unify error messages and handle 401 globally
instance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response) {
      // if 401 unauthorized, remove token and redirect to login (if running in browser)
      if (err.response.status === 401 && typeof window !== 'undefined') {
        try {
          localStorage.removeItem('token');
          window.location.pathname = '/login';
        } catch (e) {}
      }
      // attach a friendly message if not present
      err.message = err.response.data?.message || err.response.statusText || 'Request failed';
    }
    return Promise.reject(err);
  }
);

export default instance;
